import mpesaLogo from "../../assets/img/mpesalogo.jpg";
import airtelLogo from "../../assets/img/airtelmoneylogo.webp";
import { useAirtelEnabled } from "../../hooks/useAirtelEnabled";

export const PROVIDER_LOGOS = {
  Safaricom: mpesaLogo,
  Airtel: airtelLogo,
};

export const MOBILE_MONEY_PROVIDERS = [
  { value: "Safaricom", label: "Safaricom", logo: mpesaLogo },
  { value: "Airtel", label: "Airtel", logo: airtelLogo },
];

export function useMobileMoneyProviderOptions() {
  const airtelEnabled = useAirtelEnabled();
  return airtelEnabled
    ? MOBILE_MONEY_PROVIDERS
    : MOBILE_MONEY_PROVIDERS.filter((p) => p.value !== "Airtel");
}

export const renderMobileMoneyOption = ({ option }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    {option.logo && (
      <img
        src={option.logo}
        alt={option.label}
        style={{ width: 24, height: 24, objectFit: "contain", borderRadius: 4 }}
      />
    )}
    <span>{option.label}</span>
  </div>
);
